import { Injectable, Inject, Optional } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataAccess } from '../../data-access/services/data-access.service';
import { LocalStorageService } from '../../shared/services/local-storage.service';
import { Router } from '@angular/router';
import { AUTH_ROUTE_PATH } from '../providers';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  public readonly currentUser = new BehaviorSubject<any>(null);

  constructor(
    @Inject(AUTH_ROUTE_PATH) public readonly authRoute: string,
    private router: Router,
    private store: LocalStorageService,
    private dataAccess: DataAccess) {

    this.syncUser();
  }

  public hasSessionId(): boolean {
    return Boolean(this.store.get<string>('UID'));
  }

  public async login({email, password, session}): Promise<void> {

    const {data} = await this.dataAccess.execute('Login', {email, password});
    const user = data[0][0];
    this.currentUser.next(user);
    this.store.set<string>('UID', user.sessionId, session);

  }

  public async logout() {

    const {sessionId} = this.currentUser.value;
    await this.dataAccess.execute('LogOut', {sessionId});

    this.store.remove('UID');
    this.currentUser.next(null);

  }

  public async register({email, password}): Promise<void> {

    const {data} = await this.dataAccess.execute('RegisterUser', {email, password});

    const user = data[0][0];
    this.currentUser.next(user);
    this.store.set<string>('UID', user.sessionId);


  }

  private async syncUser() {

    const sessionId = this.store.get<string>('UID');
    if (sessionId === null) {
      return;
    }

    try {
      const {data} = await this.dataAccess.execute('GetUserDetails', {sessionId});
      this.currentUser.next(data[0][0]);
    } catch (err) {
      this.currentUser.next(null);
      this.store.remove('UID');
      this.router.navigate(['/', this.authRoute]);
    }
  }
}
